export default [
  {
    title: "Point Management",
    customIcon: "FlashDealSVG",
    children: [
      {
        title: "Promotion List",
        route: "custom-promotion-list",
        path: "/custom-promotion/list",
      },
    ],
  },
];
